import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValueSet, LocalService, MessageSettingsWrapper, NotificationType, InteractionType, Status, TriggeredEvent } from '../../../service/local.service';
import { LessCreditsComponent } from '../less-credits/less-credits.component';

@Component({
  selector: 'app-sms-settings',
  templateUrl: './sms-settings.component.html',
  styleUrls: ['./sms-settings.component.scss']
})
export class SmsSettingsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["sms_settings"]; source: MessageSettingsWrapper; isShowActive = true;
  businessId = ''; relationShipType: InteractionType = InteractionType.Business; notificationType: NotificationType = NotificationType.WhatsApp;
  selectedForCustomer: KeyValueSet[]; selectedForBusiness: KeyValueSet[]; isActive = false; selectedNotificationType = '';
  isAllCustomer = false; isAllBusiness = false; maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public billingManagementService: BillingManagementService, private activeModal: NgbActiveModal, public profileManagementService: ProfileManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.selectedNotificationType = this.notificationType.toString();
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.notificationType = parseInt(this.selectedNotificationType);
    let isLoadOptions = !this.source;
    this.billingManagementService.getMessageSettings(this.businessId, this.notificationType, this.relationShipType, isLoadOptions).subscribe(result => {
      if (isLoadOptions) {
        this.source = result;
      } else {
        this.source.content = result.content;
        this.source.selectedForBusiness = result.selectedForBusiness;
        this.source.selectedForCustomer = result.selectedForCustomer;
        this.source.similarSettings = result.similarSettings;
      }
      this.selectedForCustomer = [];
      this.selectedForBusiness = [];
      this.isActive = this.source.content.v4 == '1';
      this.source.options.forEach(item => {
        this.selectedForCustomer.push({
          key: item.key, value: item.value,
          isSelected: this.source.selectedForCustomer.filter(x => x.toString() == item.key).length > 0
        } as KeyValueSet);
        this.selectedForBusiness.push({
          key: item.key, value: item.value,
          isSelected: this.source.selectedForBusiness.filter(x => x.toString() == item.key).length > 0
        } as KeyValueSet);
      });
      this.isAllCustomer = this.source.options.length == this.selectedForCustomer.filter(x => x.isSelected).length;
      this.isAllBusiness = this.source.options.length == this.selectedForBusiness.filter(x => x.isSelected).length;
      this.source.content.value = this.source.content.v5 && this.source.content.v5 != '' ? parseInt(this.source.content.v5) : null;
      this.source.similarSettings.forEach(x => { x.isReadonly = x.v3 == '1' });
    });
  }

  onSave() {
    this.source.content.v4 = this.isActive ? '1' : '0';
    this.source.content.v5 = this.source.content.value ? this.source.content.value.toString() : '';
    this.source.selectedForCustomer = this.selectedForCustomer.filter(x => x.isSelected).map(x => parseInt(x.key));
    this.source.selectedForBusiness = this.selectedForBusiness.filter(x => x.isSelected).map(x => parseInt(x.key));
    this.billingManagementService.saveMessageSettings(this.source, this.source.similarSettings.filter(x => x.isReadonly).map(x => parseInt(x.key))).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.profileManagementService.getLessAlert().subscribe(result => {
          let lessCredits = result;;
          if (lessCredits.messageCredits.length > 0) {
            const modalRef = this.modalService.open(LessCreditsComponent);
            modalRef.componentInstance.lessCredits = lessCredits;
          }
        });
        this.activeModal.close({ event: TriggeredEvent.Ok });
      }
    });
  }

  onAction(index) {
    switch (index) {
      case 1: {
        this.selectedForCustomer.forEach(x => x.isSelected = this.isAllCustomer);
      } break;
      case 2: {
        this.selectedForBusiness.forEach(x => x.isSelected = this.isAllBusiness);
      } break;
      case 3: {
        this.isAllCustomer = this.source.options.length == this.selectedForCustomer.filter(x => x.isSelected).length;
      } break;
      case 4: {
        this.isAllBusiness = this.source.options.length == this.selectedForBusiness.filter(x => x.isSelected).length;
      } break;
    }
  }
}
